import { IDepartmentPermissionListSearch } from "../../../../types/permissions/departmentInterface";
import api from "../../../../lib/api";


export const getDepartmentPermissionListApi = async (data: IDepartmentPermissionListSearch) => {
  return await api.get(`department-permission/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const addDepartmentPermissionApi = async (data: any) => {
  return await api.post(`department-permission/`, data);
};